// extracted by mini-css-extract-plugin
export default {"wrap":"StepSlider_wrap__XWbl7","bubble":"StepSlider_bubble__9GdCk"};